var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9373 0.550171C10.8691 0.481437 10.788 0.426881 10.6986 0.38965C10.6093 0.35242 10.5134 0.333252 10.4166 0.333252C10.3198 0.333252 10.2239 0.35242 10.1346 0.38965C10.0452 0.426881 9.9641 0.481437 9.89593 0.550171L4.4326 6.02084L2.13726 3.71817C2.06648 3.6498 1.98292 3.59603 1.89136 3.55995C1.7998 3.52387 1.70203 3.50617 1.60363 3.50787C1.50523 3.50958 1.40813 3.53064 1.31788 3.56987C1.22762 3.6091 1.14597 3.66572 1.0776 3.7365C1.00922 3.80729 0.955459 3.89084 0.919376 3.9824C0.883293 4.07396 0.865597 4.17173 0.8673 4.27013C0.869002 4.36853 0.890069 4.46563 0.929298 4.55589C0.968526 4.64615 1.02515 4.7278 1.09593 4.79617L3.91193 7.61217C3.9801 7.6809 4.06121 7.73546 4.15057 7.77269C4.23994 7.80992 4.33579 7.82909 4.4326 7.82909C4.52941 7.82909 4.62526 7.80992 4.71462 7.77269C4.80398 7.73546 4.88509 7.6809 4.95326 7.61217L10.9373 1.62817C11.0117 1.5595 11.0711 1.47616 11.1117 1.38339C11.1524 1.29062 11.1733 1.19045 11.1733 1.08917C11.1733 0.987896 11.1524 0.887719 11.1117 0.794953C11.0711 0.702186 11.0117 0.618842 10.9373 0.550171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a3fe85a2a9c0eade5019a6af58a3498e.svg";
export { ForwardRef as ReactComponent };